export enum SignatureRoleEnum {
  Employee = 'Employee',
  Manager = 'Manager',
  HR = 'HR'
}
